var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndToEndSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61 46h-4v5l-3-2-3 2v-5h-4a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-14a1 1 0 0 0 -1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21 12h2v2h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41 12h2v2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.93 4.93h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 3.11 19.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38.07 19.07h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 -2.75 33.51)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m31 2h2v2h-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m11 62a9 9 0 1 0 -9-9 9 9 0 0 0 9 9zm1-3h-2v-2h2zm-1-12a3.5 3.5 0 0 1 1 6.85v1.65h-2v-2.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0 -1.5-1.5h-2a3.5 3.5 0 0 1 3.5-3.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m14.65 21 .94-6.6-6.59.96 2.14 2.14a25.71 25.71 0 0 0 -5.14 15.5 26.12 26.12 0 0 0 .75 6.24l1.95-.48a24 24 0 0 1 3.87-19.83z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m52.87 35.12 3.44 5.71 4.52-4.9-3-.3c.17-.87.17-1.75.17-2.63a25.94 25.94 0 0 0 -9.36-20l-1.28 1.53a24 24 0 0 1 8.64 18.47 21.67 21.67 0 0 1 -.13 2.42z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m28.79 61.83.49-3a24.66 24.66 0 0 0 2.72.17 25.69 25.69 0 0 0 9.36-1.74l-.72-1.86a24.06 24.06 0 0 1 -11 1.45l.48-2.91-5.94 3.06z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m35 23v-1h-6v1a3 3 0 0 0 6 0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m25 13a7 7 0 0 0 4 6.32v1.18h6v-1.18a7 7 0 1 0 -10-6.32z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m23.93 19.07h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 -6.89 23.51)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m38.07 4.93h2v2h-2z",
    transform: "matrix(.707 -.707 .707 .707 7.25 29.36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndToEndSolutions);
export default __webpack_public_path__ + "static/media/End-to-End Solutions.dd9787aab842e1626a54815f51ce83be.svg";
export { ForwardRef as ReactComponent };